import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { AwsImage, CmsData } from "@dotcom-frontend/data";
import {
  LgGridColDirective,
  LgGridContainerDirective
} from "@legal-and-general/canopy";
import { WysiwygDirective } from "../../../directives/wysiwyg.directive";
import { ImageComponent } from "../../globals/Image/Image.component";
import { DynamicComponent } from "../../utils/dynamic-loader/dynamic.component";
import { SafeHtmlPipe } from "../../utils/pipes/safe-html..pipe";
import { NgClass } from "@angular/common";

@Component({
  selector: "dotcom-frontend-testimonial-block",
  templateUrl: "./TestimonialBlock.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrl: "./TestimonialBlock.component.scss",
  standalone: true,
  imports: [
    LgGridContainerDirective,
    LgGridColDirective,
    ImageComponent,
    WysiwygDirective,
    SafeHtmlPipe,
    NgClass
  ]
})
export class TestimonialBlockComponent implements DynamicComponent, OnInit {
  @Input() data: CmsData | undefined;
  testimonialBlockStyle: string | undefined;
  testimonialBlockText: string | undefined;
  testimonialBlockContributorName: string | undefined;
  testimonialBlockContributorDetails: string | undefined;
  isTestimonialBlockStyleStandard = false;
  isTestimonialBlockStyleHighlighted = false;
  image: AwsImage | undefined;
  isImageLocationRight = false;

  ngOnInit() {
    if (this.data) {
      this.testimonialBlockStyle = this.data["testimonialStyle"];
      this.testimonialBlockText = this.data["testimonialText"];
      this.isTestimonialBlockStyleStandard =
        this.data["testimonialStyle"] === "standard";
      this.isTestimonialBlockStyleHighlighted =
        this.data["testimonialStyle"] === "highlighted";
      this.testimonialBlockContributorName = this.data["contributorName"];
      this.testimonialBlockContributorDetails = this.data["contributorDetails"];

      if (this.data["imagePosition"] === "right") {
        this.isImageLocationRight = true;
      }

      if (this.data["image"] && this.data["image"]["url"]) {
        this.image = this.data["image"];
      }
    }
  }
}
